"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxInput = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("../../../../../../../icons");
var themes_1 = require("../../../../../../themes");
var Tags_1 = require("../../../../../Tags");
var Typo2_1 = require("../../../../../Typo2");
var styled_1 = require("../../../../styled");
var utils_1 = require("../../../../utils");
var CheckboxButton_1 = require("../CheckboxButton");
var TextLoader_1 = require("../../../../../../../components/LoadersAndProgress/TextLoader");
var CheckSquare = icons_1.icons.CheckSquare, XSquare = icons_1.icons.XSquare;
var red = themes_1.colors.red, grey40 = themes_1.colors.grey40, grey80 = themes_1.colors.grey80, onSecondary = themes_1.colors.onSecondary, invertRed = themes_1.colors.invertRed;
var CheckboxInput = function (_a) {
    var option = _a.option, onClick = _a.onClick, S = _a.S, inputStyle = _a.inputStyle, _b = _a.value, value = _b === void 0 ? [] : _b, invert = _a.invert, disabled = _a.disabled, rightWrongResult = _a.rightWrongResult, _c = _a.className, className = _c === void 0 ? '' : _c;
    var isSelected = !!value.find(function (selOp) { return selOp.value === option.value; });
    var markingCommand = (0, utils_1.getMarkingCommand)({ option: option, isSelected: isSelected }); // returns undefined if option isn't labeled as 'correct' nor selected
    var genCheckboxButton = function (options) {
        if (options === void 0) { options = {}; }
        return (react_1.default.createElement(CheckboxButton_1.CheckboxButton, { isSelected: isSelected, disabled: disabled, invert: invert, S: S, className: "radioOrCheckboxButton_inside_input", disabled: disabled }));
    };
    var genCheckSquare = function () { return (react_1.default.createElement("div", { style: { flexShrink: 0 } },
        react_1.default.createElement(CheckSquare, { size: S ? 22.5 : 26, color: disabled ? grey40 : onSecondary, style: {
                margin: "-7px -2.8px -7px -3.2px",
                flexShrink: 0,
            } }))); };
    var genXSquare = function () { return (react_1.default.createElement(XSquare, { size: S ? 21.5 : 26, color: invert ? invertRed : red, style: {
            margin: "-7px -2.8px -7px -3.2px",
            flexShrink: 0,
        } })); };
    return option.loading ? (react_1.default.createElement(TextLoader_1.TextLoader, { style: { width: "8rem", height: "1.5rem" } })) : inputStyle === "tagSelect" ? (react_1.default.createElement(Tags_1.TagSelect, { isSelected: isSelected, invert: invert, disabled: disabled, onClick: function () { return !disabled && onClick(isSelected, option); }, display: option.display, value: option.value, style: { alignSelf: "flex-start" } })) : (react_1.default.createElement(styled_1.StyledOption, { rightWrongResult: rightWrongResult, isSelected: isSelected, disabled: disabled, invert: invert, S: S, className: className, onClick: function () {
            return !rightWrongResult && !disabled && onClick && onClick(isSelected, option);
        } },
        react_1.default.createElement("div", { style: { alignSelf: "flex-start" } }, rightWrongResult
            ? ["markCorrect", "revealCorrect"].includes(markingCommand)
                ? genCheckSquare()
                : markingCommand === "markWrong"
                    ? genXSquare()
                    : genCheckboxButton({ disabled: true }) //else rightWrongResult has come in, but this doesnt have to be marked right or wrong
            : genCheckboxButton() // rightWrongResult has not come in. so gen normal radio button
        ),
        react_1.default.createElement(Typo2_1.UI_BODY_SM_DF, { bold: rightWrongResult && isSelected, color: disabled ? grey40 : grey80, invert: invert }, option.display)));
};
exports.CheckboxInput = CheckboxInput;
